import {Injectable} from '@angular/core';
import {Headers, Http, RequestOptions, Response, ResponseContentType} from '@angular/http';
import {Observable} from 'rxjs/Observable';

import {environment} from 'environment';

@Injectable()
export class UserImportRepository {

  constructor(private http: Http) { }

  public startImport(file: File): Observable<Response> {
    const options: RequestOptions = new RequestOptions({
      withCredentials: true,
    });

    const formData: FormData = new FormData();
    formData.append('usersFile', file, file.name);

    return this.http.post(environment.userImport, formData, options)
      .map((res: Response) => {
        return res.json();
      });
  }

  public getSampleCSV(): Observable<Blob> {
    const options: RequestOptions = new RequestOptions({withCredentials: true, responseType: ResponseContentType.Blob});

    return this.http.get(`${environment.csvSample}`, options)
            .map((response: Response) => {
              return response.blob();
            });
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/user/user-import/repositories/user-import.repository.ts